import { render, staticRenderFns } from "./RouterLinks.vue?vue&type=template&id=80651a72&"
import script from "./RouterLinks.vue?vue&type=script&lang=js&"
export * from "./RouterLinks.vue?vue&type=script&lang=js&"
import style0 from "./RouterLinks.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "RouterLinks.vue"
export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib'
installComponents(component, {
  VIcon,
})
